import { useMutation } from '@tanstack/react-query'
import { postNamedCommand } from '../service'

export function useApproveWorkflowGate () {
  return useMutation({
    mutationFn: ({ executionId, stepId, comment = '' }) =>
      postNamedCommand('dagger', 'approve-workflow-gate', { executionId, stepId, comment })
  })
}

export function useRejectWorkflowGate () {
  return useMutation({
    mutationFn: ({ executionId, stepId, comment = '' }) =>
      postNamedCommand('dagger', 'reject-workflow-gate', { executionId, stepId, comment })
  })
}
